import { MANAGEMENT_TOOLBAR_CONTROL_HEIGHT_PX } from "../utils/management-toolbar.constants";

/** 44×44 touch target for Management icon buttons (back, drill, period chevrons). */
export const managementTouchIconButtonSx = {
  width: MANAGEMENT_TOOLBAR_CONTROL_HEIGHT_PX,
  height: MANAGEMENT_TOOLBAR_CONTROL_HEIGHT_PX
} as const;
